import axios, { baseUrl } from './axios';
import queryString from 'query-string';

export default {
  loadBookingList: async (options = {}) => {
    const params = queryString.stringify(
      Object.assign(
        { offset: options.offset, limit: options.limit },
        options.filter,
      ),
    );
    const result = await axios.get(
      `${baseUrl}/scheduler/mob/organisations/${
        options.organisationId
      }/bookings${params ? `?${params}` : ''}`,
    );
    return result.data;
  },

  loadBookingSlotList: async (options = {}) => {
    const params = queryString.stringify(
      Object.assign(
        { offset: options.offset, limit: options.limit },
        options.filter,
      ),
    );
    const result = await axios.post(
      `${baseUrl}/scheduler/mob/booking_slots${params ? `?${params}` : ''}`,
      options.packageDuration,
    );
    return result.data;
  },

  holdBookingSlot: async data => {
    const result = await axios.post(
      `${baseUrl}/scheduler/mob/holdcalendars`,
      data,
    );
    return result.data;
  },
  releaseBookingSlot: async data => {
    const params = queryString.stringify(
      Object.assign({ offset: data.offset, limit: data.limit }, data.filter),
    );

    if (data.uuid) {
      const result = await axios.delete(
        `${baseUrl}/scheduler/mob/holdcalendars/${data.uuid}${
          params ? `?${params}` : ''
        }`,
        data,
      );
      return result.data;
    }
  },

  bookAppointment: async options => {
    const params = queryString.stringify(
      Object.assign(
        { offset: options.offset, limit: options.limit },
        options.filter,
      ),
    );
    const result = await axios.post(
      `${baseUrl}/scheduler/mob/organisations/${
        options.organisationId
      }/appointments${params ? `?${params}` : ''}`,
      options,
    );
    return result.data;
  },

  bookAppointmentAMC360: async options => {
    const params = queryString.stringify(
      Object.assign(
        { offset: options.offset, limit: options.limit },
        options.filter,
      ),
    );
    const result = await axios.post(
      `${baseUrl}/scheduler/mob/organisations/${
        options.organisationId
      }/appointments${params ? `?${params}` : ''}`,
      options,
    );
    return result.data;
  },

  createConsultationAMC360: async options => {
    const result = await axios.post(
      `${baseUrl}/medicare/mob/organisations/${
        options.organisationId
      }/consultations`,
      options.data,
    );
    return result.data;
  },

  loadBookingDetail: async options => {
    const params = queryString.stringify(
      Object.assign(
        { offset: options.offset, limit: options.limit },
        options.filter,
      ),
    );
    const result = await axios.get(
      `${baseUrl}/scheduler/mob/organisations/${
        options.organisationId
      }/appointment/${options.appointmentId}${params ? `?${params}` : ''}`,
      options,
    );
    return result.data;
  },

  rescheduleBooking: async data => {
    const result = await axios.post(
      `${baseUrl}/scheduler/mob/organisations/${
        data.organisationId
      }/appointments/rescheduled`,
      data,
    );
    return result.data;
  },
  cancelBooking: async data => {
    const result = await axios.delete(
      `${baseUrl}/scheduler/mob/organisations/${
        data.organisationId
      }/appointments/cancel/${data.appointmentId}`,
      data,
    );
    return result.data;
  },
  updateBookingInfo: async data => {
    const result = await axios.put(
      `${baseUrl}/scheduler/mob/organisations/${
        data.organisationId
      }/appointment/${data.appointmentId}`,
      data,
    );
    return result.data;
  },
  updateBookingAMC360Info: async options => {
    const result = await axios.post(
      `${baseUrl}/scheduler/mob/organisations/${
        options.organisationId
      }/submit/${options.appointmentId}`,
      options.data,
    );
    return result.data;
  },
};
